import { BOOKING_APIS } from "@/api_framework/api_config";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import { useAPIUtils } from "../../useAPIUtils";
import { useConfiguration } from "../../useConfiguration";
import { useCurlLogger } from "../../useCurlLogger";
type InventoryTaxCreateAPIResponse = { status: boolean; message: string };

AxiosCurlirize(axios, () => {});

export const useBookingHistoryAPI = () => {
  const [bookingDetails, setBookingDetails] = useState<any>([]);
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();
  const execute = useCallback(
    async (bookingId: string) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);

        const response: InventoryTaxCreateAPIResponse = await axios
          .get(`${BOOKING_APIS?.BOOKING_HISTORY?.baseURL}?booking_id=${bookingId}`, {
            params: {},
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<any>) => {
            if (res.data.status === true && res.data) {
              setBookingDetails(res.data.data);
              return { status: true, message: "batch" };
            } else {
              setBookingDetails([]);
              return { status: false, message: "batch" };
            }
          })
          .catch((e: AxiosError) => {
            setBookingDetails([]);
            sendCurl(e.config["curlCommand"]);
            if (e.code === "ERR_NETWORK") {
              toast.error("Network Error");
              return { status: false, message: "batch" };
            }
            if (e.status === 400) {
              return { status: false, message: "batch" };
            }
            return { status: false, message: "batch" };
          });
        return response;
      } catch (e: any) {
        captureError(e);
        setBookingDetails([]);

        return { status: false, message: "batch" };
      }
    },
    [dispatch],
  );
  return { bookingDetails, execute };
};
